import React from 'react'
import LoadingBox from 'src/ui/LoadingBox/LoadingBox'
import GoalSettingSkeleton from './GoalSettingSkeleton'

const GoalSettingPlaceholder: React.FC = () => {
  return (
    <GoalSettingSkeleton
      titleSection={<LoadingBox width="150px">&nbsp;</LoadingBox>}
      goalSection={<LoadingBox width="100%" height="500px" borderRadius="1x" />}
    />
  )
}

export default GoalSettingPlaceholder
